module.exports = __webpack_public_path__ + "images/error_satellite.svg?93591300162e5b07020d84f0a02d19bf";